/* eslint-disable prefer-const */
import $ from "jquery";
import AjaxBlocking from "./AjaxBlocking";
import Dropdown from "./Dropdown";
import Notices from "./Notices";

export default class QuantityButtons {
	constructor() {
		this.buttonInitialized = false;

		this.events();
	}

	events() {
		const self = this;
		this.setButtonsEvents();

		$(document.body).on("updated_wc_div", function () {
			self.setButtonsEvents();
		});
	}

	setButtonsEvents() {
		// eslint-disable-next-line no-new
		new Dropdown();

		this.quantityContainer = [...document.querySelectorAll(".quantity-wrapper .quantity")];
		this.updateCartBtn = document.querySelector('button[name="update_cart"]');
		this.jsClearCart = document.querySelector(".jsClearCart");

		this.cartPage = document.querySelector("body.woocommerce-cart");
		this.cartForm = document.querySelector(".woocommerce-cart-form");
		this.isCartPage = !!this.cartPage;

		if (this.jsClearCart) {
			this.jsClearCart.addEventListener("click", this.clearCart.bind(this));
		}

		if (this.cartForm) {
			this.cartForm.addEventListener("keypress", (event) => {
				if (event.key === "Enter") {
					event.preventDefault();
				}
			});
		}
		if (!this.quantityContainer.length) return;

		this.quantityContainer.forEach((item) => {
			const minusBtn = item.querySelector(".quantity-minus");
			const plusBtn = item.querySelector(".quantity-plus");
			const quantity = item.querySelector('input[type="number"]');

			minusBtn.addEventListener("click", (e) => {
				this.subtractProduct(e, item, quantity);
			});

			plusBtn.addEventListener("click", (e) => {
				this.addProduct(e, item, quantity);
			});

			quantity.addEventListener("blur", (e) => {
				this.changeQuantity(e, item, quantity);
			});
		});

		this.buttonInitialized = true;
	}

	addProduct(e, item, quantity) {
		let value = parseInt(quantity.value, 10);
		const maxVal = parseInt(quantity.max, 10);

		if (this.isCartPage) {
			if (!maxVal || (maxVal && value < maxVal)) {
				quantity.value = value + 1;
			} else {
				quantity.value = maxVal;

				const myFormData = new FormData();
				myFormData.append("security", window.global.security);
				myFormData.append("product_id", quantity.closest(".cart__product-quantity").dataset.productId);

				$(document.body).on("updated_cart_totals", function () {
					fetch(window.global.ajax_url + "?action=addNotice", {
						method: "POST",
						mode: "cors",
						cache: "no-cache",
						credentials: "same-origin",
						redirect: "follow",
						referrerPolicy: "no-referrer",
						body: myFormData,
					})
						.then((resp) => resp.json())
						.then((res) => {
							if (res.success) {
								const notices = new Notices();
								notices.addNotices(res.data.notices, 10000);
							}
						});
				});
			}

			this.changeQtyTimeout();
		} else {
			if (!maxVal || (maxVal && value < maxVal)) {
				quantity.value = value + 1;
			} else {
				quantity.value = maxVal;
			}
		}
	}

	subtractProduct(e, item, quantity) {
		let value = parseInt(quantity.value, 10);
		const minVal = parseInt(quantity.min, 10);

		if ((!minVal && value > 1) || (minVal && minVal < value)) {
			quantity.value = value - 1;
		} else if (minVal && minVal >= value) {
			quantity.value = minVal;
		} else {
			quantity.value = value;
		}

		if (this.isCartPage) this.changeQtyTimeout();
	}

	changeQuantity(e, item, quantity) {
		let value = parseInt(quantity.value, 10);
		const minVal = parseInt(quantity.min, 10);
		const maxVal = parseInt(quantity.max, 10);

		if (!minVal && value < 1) {
			quantity.value = 1;
		} else if (minVal && value < minVal) {
			quantity.value = minVal;
		} else if (maxVal && value > maxVal) {
			quantity.value = maxVal;
		} else {
			quantity.value = value;
		}

		if (this.isCartPage) this.changeQtyTimeout();
	}

	changeQtyTimeout() {
		const self = this;

		if (self.timeout !== undefined) {
			clearTimeout(self.timeout);
		}

		self.timeout = setTimeout(() => {
			self.updateCart();
		}, 1000);
	}

	clearCart() {
		this.blockForAjax(this.cartForm);
		const myFormData = new FormData();
		myFormData.append("security", window.global.security);

		fetch(window.global.ajax_url + "?action=clearCart", {
			method: "POST",
			mode: "cors",
			cache: "no-cache",
			credentials: "same-origin",
			redirect: "follow",
			referrerPolicy: "no-referrer",
			body: myFormData,
		})
			.then((resp) => resp.json())
			.then((res) => {
				if (res.success) {
					location.reload();
				} else {
					this.unblockForAjax(this.cartForm);
				}
			});
	}

	updateCart() {
		this.updateCartBtn.setAttribute("aria-disabled", "false");
		this.updateCartBtn.removeAttribute("disabled");
		$('[name="update_cart"]').trigger("click");
		this.updateCartBtn.click();

		this.buttonInitialized = false;
	}

	blockForAjax(element) {
		if (!element) return;

		const myBlock = new AjaxBlocking();
		myBlock.blockOnAjax(element);
	}

	unblockForAjax(element) {
		if (!element) return;

		const myBlock = new AjaxBlocking();
		myBlock.unblockOnAjax(element);
	}
}
